var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 21.7546,
    rx: 2.5,
    stroke: "#238EF8",
    strokeOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1363_12154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.43945C13.5 7.32342 13.4539 7.21214 13.3719 7.13009C13.2898 7.04805 13.1785 7.00195 13.0625 7.00195C12.9465 7.00195 12.8352 7.04805 12.7531 7.13009C12.6711 7.21214 12.625 7.32342 12.625 7.43945V12.252C12.625 12.3291 12.6454 12.4048 12.6842 12.4715C12.7229 12.5382 12.7785 12.5935 12.8455 12.6317L15.908 14.3817C16.0085 14.436 16.1263 14.4489 16.2361 14.4175C16.346 14.3861 16.4392 14.3131 16.4959 14.2139C16.5525 14.1147 16.5682 13.9973 16.5394 13.8867C16.5107 13.7761 16.4398 13.6812 16.342 13.6222L13.5 11.9982V7.43945Z",
    fill: "#238EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.377C15.3565 18.377 17.137 17.6395 18.4497 16.3267C19.7625 15.0139 20.5 13.2335 20.5 11.377C20.5 9.52044 19.7625 7.73996 18.4497 6.42721C17.137 5.11445 15.3565 4.37695 13.5 4.37695C11.6435 4.37695 9.86301 5.11445 8.55025 6.42721C7.2375 7.73996 6.5 9.52044 6.5 11.377C6.5 13.2335 7.2375 15.0139 8.55025 16.3267C9.86301 17.6395 11.6435 18.377 13.5 18.377ZM19.625 11.377C19.625 13.0014 18.9797 14.5593 17.831 15.708C16.6824 16.8566 15.1245 17.502 13.5 17.502C11.8755 17.502 10.3176 16.8566 9.16897 15.708C8.02031 14.5593 7.375 13.0014 7.375 11.377C7.375 9.7525 8.02031 8.19458 9.16897 7.04592C10.3176 5.89726 11.8755 5.25195 13.5 5.25195C15.1245 5.25195 16.6824 5.89726 17.831 7.04592C18.9797 8.19458 19.625 9.7525 19.625 11.377Z",
    fill: "#238EF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_12154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6.5 4.37695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.35cfd9b1a7c7d188101ce4d0d423f0c4.svg";
export { ForwardRef as ReactComponent };